







































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import { Product, Brand } from "@/models";
import CompanyMixin from "@/mixins/http/Agents/Company";
import ClientCompany from "@/models/Agents/Company";
import EntryListGroupVariant from "./EntryListGroupVariant.vue";

const DEFAULT_PLACEHOLDER = "Cerca aziende/brand/prodotti";
const DEFAULT_MIN = 1;
const DEFAULT_DELAY = 1000;

const REQUEST_TAG = "agents_company_index";

export interface EntrySearchResult {
  clientCompanies: ClientCompany[];
  total: number;
}

@Component({ components: { EntryListGroupVariant } })
export default class ClientCompanySearch extends Mixins(CompanyMixin) {
  @Prop({ default: DEFAULT_PLACEHOLDER }) readonly placeholder?: string;
  @Prop({ default: DEFAULT_MIN }) readonly min?: number;
  @Prop({ default: DEFAULT_DELAY }) readonly delay?: number;
  @Prop({ default: false }) readonly selectable?: boolean;
  @Prop({ default: "right" }) readonly iconAlign?: string;
  @Prop() readonly size?: string;
  @Prop({ default: "" }) readonly dropdownSize!: string;
  @Prop() readonly label?: string | undefined;
  @Prop({ default: "" }) readonly dropdownAlign!: string;

  @Prop({ default: true }) readonly companiesEnabled?: boolean;
  @Prop({ default: true }) readonly brandsEnabled?: boolean;
  @Prop({ default: true }) readonly productsEnabled?: boolean;

  @Getter("profile") readonly profile!: AdcontrolProfile;

  term = this.label ?? "";
  timeout: number | undefined;

  companies: ClientCompany[] = [];
  brands: Brand[] = [];
  products: Product[] = [];

  searching = false;

  dropdownVisible = false;

  @Watch("label", { immediate: true })
  onLabelUpdated() {
    this.term = this.label ?? "";
  }

  get results(): EntrySearchResult {
    return {
      clientCompanies: this.companies,
      total: this.companies.length + this.brands.length + this.products.length,
    };
  }

  protected onKeyUp() {
    if (this.min && this.term.length >= this.min) {
      this.clearTimeout();

      this.timeout = setTimeout(() => {
        this.search();
      }, this.delay);
    } else if (this.term.length == 0) {
      this.clearSearch();
      this.emitResults();
    }
  }

  get queryTerm(): string {
    return `cliente`;
  }

  get showTitles(): boolean {
    return (
      Number(this.companiesEnabled) +
        Number(this.brandsEnabled) +
        Number(this.productsEnabled) >
      1
    );
  }

  async search() {
    this.searching = true;
    this.$emit("searching");
    try {
      await this.searchCompanies();
    } finally {
      this.searching = false;
      this.clearTimeout();
    }
    this.$emit("searched", this.results);
    if (this.selectable) {
      this.showDropdown();
    }
  }

  async searchCompanies() {
    this.companies = await this.getCompanies(REQUEST_TAG, this.profile.slug, {
      "filter[term]": this.term,
      "filter[principals]": 1,
    });
  }

  public focus() {
    (this.$refs.input as HTMLInputElement).focus();
  }

  clearSearch() {
    this.companies = [];
    this.brands = [];
    this.products = [];
    this.term = "";
    this.$emit("search-cleared");
  }

  emitResults() {
    this.$emit("searched", this.results);
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  protected showDropdown() {
    this.dropdownVisible = true;
  }

  protected closeDropdown() {
    this.dropdownVisible = false;
  }

  protected onSelected(value: ClientCompany) {
    this.term = value.name;
    this.$emit("selected", value.clone());
    this.closeDropdown();
  }
}
